import React from 'react';

import useOneOnOnePageParams from 'screens/oneOnOneRabbit/hooks/useOneOnOnePageParams';

import { DetailsRabbit } from 'assets/assetsV1/iconComponents';

import { sendAddedOneOnOneNotesEvent } from 'constants/mixpanelHelper';

import { Divider } from 'uiToolkitV1/Divider';

import { CardTemplate } from '../../common/CardTemplate';
import RichTextNote from './RichTextNote';
import { useOneOnOneNotesQuery, useUpdateOneOnOneInstanceNotesMutation } from './hooks/dataHooks';

const MeetingNotes = () => {
  const { masterId, instanceId } = useOneOnOnePageParams();

  const { data: sharedNote, isLoading } = useOneOnOneNotesQuery({
    masterId,
    instanceId,
    isPrivate: false,
  });
  const { data: privateNote, isLoading: isLoadingPrivate } = useOneOnOneNotesQuery({
    masterId,
    instanceId,
    isPrivate: true,
  });

  const updateInstanceNotesMutation = useUpdateOneOnOneInstanceNotesMutation({
    masterId,
    instanceId,
  });

  const onInstanceNotesChange = async ({
    feedbackText,
    feedbackTextHtml,
    isPrivate,
  }: {
    feedbackText: string;
    feedbackTextHtml: string;
    isPrivate: boolean;
  }) => {
    const instanceDataId = isPrivate ? privateNote?.instanceDataId : sharedNote?.instanceDataId;
    if ((isPrivate ? privateNote?.feedbackText : sharedNote?.feedbackText)?.trim() === feedbackText.trim()) {
      return;
    }
    if (feedbackText.trim() !== '' || feedbackTextHtml.trim() !== '') {
      updateInstanceNotesMutation.mutate({
        instanceDataId,
        isPrivate,
        feedbackText,
        feedbackTextHtml,
      });
    } else {
      // If both feedbackText and feedbackTextHtml are empty, we want to delete the existing notes.
      updateInstanceNotesMutation.mutate({
        instanceDataId,
        isPrivate,
        feedbackText: '',
        feedbackTextHtml: '',
      });
    }
    sendAddedOneOnOneNotesEvent({
      eventProperties: {
        instance_id: instanceId,
        type: isPrivate ? 'Private' : 'Public',
      },
    });
  };

  if (isLoading || isLoadingPrivate) {
    return null;
  }
  return (
    <CardTemplate heading="Notes" Icon={DetailsRabbit} testId="meeting-notes-container">
      <RichTextNote
        label="Shared Notes (visible to both)"
        onChange={onInstanceNotesChange}
        isPrivate={false}
        p="24px 16px"
        testId="meeting-notes-shared-notes"
        {...sharedNote}
      />
      <Divider opacity={1} color="#EBEFF3" />
      <RichTextNote
        label="Private Notes (visible only to you)"
        onChange={onInstanceNotesChange}
        isPrivate
        p="24px 20px 18px 16px"
        testId="meeting-notes-private-notes"
        {...privateNote}
      />
    </CardTemplate>
  );
};

export { MeetingNotes };
